module.exports = __webpack_public_path__ + "static/media/2.9a4f33b2.jpg";